import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { T } from "react-translator-component";
import EventApplicationDetails from "./EventApplicationDetails";
import { Box, Button, SelectChangeEvent } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import GCBackButton from "../GreenCity/GCBackButton";
import LoadingModal from "../LoadingModal";
import appServices from "../../services/app-services/appServices";

const UserEventPaymentDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { postId } = location.state || {};
  const [checkIfValueIsSelected, setCheckIfValueIsSelected] = useState(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [postDetail, setPostDetail] = useState<any>();
  const [postEvent, setPostEvent] = useState<any>();
  const [selectedValues, setSelectedValues] = useState<any>();

  // Handle change for dropdowns
  const handleChange = (index: number) => (event: SelectChangeEvent) => {
    const newValues = [...selectedValues];
    newValues[index] = parseInt(event.target.value, 10);
    // Check if all elements are 0
    const isAllZero = newValues.every((num) => num === 0);
    setCheckIfValueIsSelected(isAllZero);
    setSelectedValues(newValues);
  };

  const getPostDetail = async () => {
    setLoading(true)
    try {
      const res = await appServices.getSingleEventById(postId);
      setPostDetail(res?.post)
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPostDetail()
  }, [])

  useEffect(() => {
    if (!postDetail) return

    const targetPostEvent = postDetail?.post_events[0]
    setPostEvent(targetPostEvent)
    setSelectedValues(targetPostEvent.participant_settings?.map(() => 0))
  }, [postDetail])

  return (
    <Box sx={{ marginTop: 12, padding: "0 20px" }}>
      <LoadingModal visible={loading} handleClose={() => {}} />
      <Box sx={{ marginBottom: "-20px", marginLeft: "-12px" }}>
        <GCBackButton onClick={() => navigate(-1)} />
      </Box>
      {postEvent?.participant_settings?.length > 0 && (
        <Box>
          <EventApplicationDetails
            item={postDetail}
            selectedValues={selectedValues}
            handleChange={handleChange}
          />
          <Button
            color="secondary"
            sx={style.submitButton}
            size={"large"}
            disabled={checkIfValueIsSelected}
            variant="outlined"
            onClick={() =>
              navigate("/eventapplicationpayment", {
                state: {
                  item: postDetail,
                  selectedValues: selectedValues,
                },
              })
            }
            endIcon={
              <ArrowForwardIosIcon
                sx={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                  margin: "10px",
                }}
              />
            }
          >
            {T("confirm_application")}
          </Button>
        </Box>
      )}
    </Box>
  );
};
const style = {
  optionButton: {
    border: "1px solid #4792E0",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "3px",
  },
  submitButton: {
    width: "80%",
    alignSelf: "center",
    margin: "0 auto",
    marginTop: "20px",
    display: "flex",
    borderRadius: 20,
    border: "2px solid",
  },
};
export default UserEventPaymentDetail;
